/*
 * @Description: 操作日志路由
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const storageFeeRouter: Array<RouteRecordRaw> = [
	{
		path: '/storage',
		component: Layout,
		redirect: '/storage/storageFee',
		children: [
			{
				path: 'storageFee',
				component: () => import(/* webpackChunkName: "storageFee" */ '@/views/vipManagement/storage/storageFee.vue'),
				name: 'storageFee',
				meta: { title: '空间存储' }
			},
			{
				path: 'courseLists',
				component: () => import(/* webpackChunkName: "courseLists" */ '@/views/vipManagement/storage/courseLists.vue'),
				name: 'courseLists',
				meta: { title: '课程空间存储' }
			},
			{
				path: 'resourceLists',
				component: () => import(/* webpackChunkName: "ResourceLists" */ '@/views/vipManagement/storage/resourceLists.vue'),
				name: 'resourceLists',
				meta: { title: '备课区空间存储' }
			},
			{
				path: 'vtrLists',
				component: () => import(/* webpackChunkName: "VtrLists" */ '@/views/vipManagement/storage/vtrLists.vue'),
				name: 'vtrLists',
				meta: { title: '虚拟教研室空间存储' }
			},
		]
	}
]

export default storageFeeRouter
